/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import { ApplyFirmwareController } from './firmware.controller';
import  FirmwareStatusTableConfig from './firmware-status-table.config';

export default angular.module('tektelic.firmware', [])
    .factory('firmwareStatusTableConfig', FirmwareStatusTableConfig)
    .controller('ApplyFirmwareController', ApplyFirmwareController)
    .name;


// WEBPACK FOOTER //
// ./src/app/firmware/index.js